import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Button, IconButton } from '@material-ui/core'
import { ViewList } from '@material-ui/icons'
import { Calendar } from 'mdi-material-ui'
import { toggleView, manuallyToggleView } from 'actions/tasks'
import language from 'utils/vast-languagepack'

export default connect(
  (state) => ({ viewSelected: state.tasks.viewSelected }),
  (dispatch) =>
    bindActionCreators({ toggleView, manuallyToggleView }, dispatch),
)(
  withStyles((theme) => ({
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    toggleViewButton: {
      color: '#fff',
      [theme.breakpoints.down('xs')]: {
        color: '#fff',
        padding: '6px 8px',
      },
      [theme.breakpoints.up('sm')]: {
        padding: '8px',
      },
    },
  }))(({ viewSelected, toggleView, icon, classes, campaignPage, manuallyToggleView }) => {
    const ButtonComponent = icon ? IconButton : Button
    const iconClassName = icon ? null : classes.leftIcon
    const label =
      viewSelected === 'list'
        ? language.general.shared.calendarView
        : language.general.shared.listView

    return (
      <ButtonComponent
        style={campaignPage ? { color: '#fff' } : null}
        onClick={() =>
          Promise.resolve(toggleView()).then(() => manuallyToggleView())
        }
        className={classes.toggleViewButton}
        aria-label={label}
      >
        {viewSelected === 'list' ? (
          <Calendar fontSize="small" className={iconClassName} />
        ) : (
          <ViewList fontSize="small" className={iconClassName} />
        )}
        {icon ? null : label}
      </ButtonComponent>
    )
  }),
)
